var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import { withPromise } from '@rad/utility/promise';
import { postObjectJson } from '../../../utility/request';
import CInput from '../input';
import CErrors from '../errors';
import { scrollToTop } from '@rad/utility/form';
export default (props) => {
    var _a, _b, _c;
    const [state, mutators] = useStateWithMutators({
        forms: {
            user: {
                loading: false,
                error: null,
                firstname: '',
                lastname: '',
                email: '',
                merchant_id: (_b = (_a = props.merchantData) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
                industry: props.industry,
            },
        },
    });
    React.useEffect(() => {
        var _a, _b;
        mutators.forms.user.merchant_id((_b = (_a = props.merchantData) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '');
    }, [(_c = props.merchantData) === null || _c === void 0 ? void 0 : _c.id]);
    const submit = () => withPromise(() => mutators.forms.user.loading(true), () => mutators.forms.user.loading(false), () => __awaiter(void 0, void 0, void 0, function* () {
        mutators.forms.user.error(null);
        yield postObjectJson('/users', state.forms.user, {
            success: () => {
                props.onUpdateUserData(state.forms.user);
                props.onNavigateToStep();
            },
            error: (res) => __awaiter(void 0, void 0, void 0, function* () {
                mutators.forms.user.error(yield res.json());
                scrollToTop();
            }),
        });
    }));
    return (_jsxs("div", { className: "d-flex flex-column gap-3 justify-content-center", children: [_jsxs("div", { className: "text-center", children: [_jsx("h1", { children: "Create User" }), _jsx("p", { children: "Add the business owner as the first user" })] }), _jsxs("form", { className: "d-flex flex-column gap-5 justify-content-center", onSubmit: (e) => {
                    e.preventDefault();
                    submit();
                }, children: [state.forms.user.error && (_jsx("div", { className: "text-danger bg-danger-subtle p-3 rounded-4", children: _jsx(CErrors, { errors: state.forms.user.error, mapping: {} }) })), _jsxs("div", { className: "bg-white rounded-4 p-5 shadow", children: [_jsxs("div", { className: "row g-3", children: [_jsx("div", { className: "col-md-6", children: _jsx(CInput, { type: "text", value: state.forms.user.firstname, onChange: mutators.forms.user.firstname, disabled: state.forms.user.loading, required: true, children: "First Name" }) }), _jsx("div", { className: "col-md-6", children: _jsx(CInput, { type: "text", value: state.forms.user.lastname, onChange: mutators.forms.user.lastname, disabled: state.forms.user.loading, required: true, children: "Last Name" }) })] }), _jsx("div", { className: "mb-3", children: _jsx(CInput, { type: "email", value: state.forms.user.email, onChange: mutators.forms.user.email, disabled: state.forms.user.loading, required: true, children: "Email" }) })] }), _jsx("div", { className: "row justify-content-center", children: _jsx("div", { className: "col-md-5 text-center", children: _jsx("button", { type: "submit", className: "btn btn-primary fs-5 w-100 rounded-4", disabled: state.forms.user.loading, children: state.forms.user.loading ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm me-2", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }), "Create Account"] })) : ('Create Account') }) }) })] })] }));
};
